import React from "react";
import AxiosServices from "./AxiosService";

const Auth = new AxiosServices();


class EmailtemplateServie {

     getData = async () => {
          return Auth.get('/EmailTemplate/GetEMailPartial')        
    };
    Create = async (EmpID) => {
     return Auth.get(`/Employee/Create?id=${EmpID}`)        
     };
     CreateUpdateEmailtemplate = async (obj) => {
          return Auth.post(`/EmailTemplate/CreateUpdateEmailtemplate`,obj)        
          
     };
     DeleteTemplate = async (val) => {
          return Auth.get(`/EmailTemplate/EmailDelete?id=${Number(val)}&ModifiedBy=${val}`,)        
     };

     GetModuleNameChanged = async (id) => {
          return Auth.get(`/EmailTemplate/ModuleNameChanged?id=${Number(id)}`,)        
     };

     Createtemplate = async (EmpID) => {
          return Auth.get(`/EmailTemplate/Index?id=${EmpID}`,)        
     };
     
     GetModuleFuncNameChanged = async (Ids) => {
          return Auth.get(`/EmailTemplate/ModuleFuncNameChanged?id=${Number(Ids)}`,)        
     };


     
}

export default EmailtemplateServie

